import type { HttpClient } from '../http';
import { unwrap, type ApiEnvelope } from '../envelope';
import type { CreatePaymentRequest, PaymentResponse } from '../types/domain';

export function paymentEndpoints(http: HttpClient) {
  return {
    create: (body: CreatePaymentRequest) => http.post<ApiEnvelope<PaymentResponse>>('/v1/payments', body).then(unwrap),
    list: (range: { from?: string; to?: string } = {}) => http.get<ApiEnvelope<PaymentResponse[]>>('/v1/payments', { query: { from: range.from, to: range.to } }).then(unwrap),
  };
}
export type PaymentEndpoints = ReturnType<typeof paymentEndpoints>;
